<template>
  <div>
    <b-row class="container-top-bar">
      <b-col>
        <b-navbar toggleable="lg" type="dark" variant="default">
          <b-navbar-toggle target="navCollapse"></b-navbar-toggle>
          <b-navbar-brand href="#">{{ system_config.quickquote_title }}</b-navbar-brand>
        </b-navbar>
      </b-col>
    </b-row>
    <b-row class="container-header">
      <b-col>
        <b-jumbotron :lead="system_config.firm_name">
        </b-jumbotron>
      </b-col>
    </b-row>
    <b-container class="mb-5">
      <h1 style="color: white;">Under construction123</h1>
    </b-container>
    <div>
      <div class="container-fluid footer fixed-bottom">
        <p class="text-center">Copyright &copy {{ new Date().getFullYear() }}, Pacioli2.</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { firebase } from '../util/firebase';

@Component({
  components: {
  },
})

export default class TermsOfService extends Vue {

    protected system_config: any = {
      quickquote_title: 'Pacioli2',
      firm_name: '',
    };
    protected created() {
      firebase.firestore().collection('system_config').doc('quickquote.title').get().then((doc) => {
        this.system_config.quickquote_title = doc.data().value;
      })
      firebase.firestore().collection('system_config').doc('firm.name').get().then((doc) => {
        this.system_config.firm_name = doc.data().value;
      })
    }

}
</script>
